import { useState } from 'react';

// import CommonImage from '@/components/CommonImage';
import EditJourneyModal from '@/features/task-configuration/components/EditJourneyModal';
import { useGetProductDevJourneyQuery } from '@/features/task-configuration/api/taskConfigurationApi';

const TaskJourneyConfiguration = () => {
	const [selectedJourneyToEdit, setSelectedJourneyToEdit] = useState(null);
	const { data: productJourneyList, refetch } = useGetProductDevJourneyQuery();

	return (
		<>
			<div className="journey-configuration-container py-2">
				<div className="journey-configuration-table mt-3">
					<table className="table with-border">
						<thead>
							<tr>
								<th>SL ({productJourneyList?.length})</th>
								<th>Journey Name</th>
								<th>Journey start</th>
								<th>Journey middle</th>
								<th>Journey End</th>
								{/* <th>Action</th> */}
							</tr>
						</thead>
						<tbody>
							{productJourneyList?.map((journey, index) => (
								<tr key={journey?.id}>
									<td className="sl-column">{index + 1}</td>
									<td className="journey-name-column">{journey?.name}</td>
									<td className="journey-start-column">
										{journey?.startActions?.map((startAction) => (
											<p key={startAction?.id} className="pl-1">
												-{startAction?.name}
											</p>
										))}
									</td>
									<td className="journey-end-column">
										{journey?.midActions?.map((midAction) => (
											<p key={midAction?.id} className="pl-1">
												-{midAction?.name}
											</p>
										))}
									</td>
									<td className="journey-end-column">
										{journey?.endActions?.map((endAction) => (
											<p key={endAction?.id}>{endAction?.name}</p>
										))}
									</td>
									{/* <td className="action-column">
										<div className="option">
											<div className="dropdown">
												<button
													aria-expanded="false"
													className="btn btn-default dropdown-toggle"
													data-toggle="dropdown"
													id="menu1"
													type="button"
												>
													<CommonImage src="/icons/more_icon.svg" alt="more_icon" />
												</button>
												<ul className="dropdown-menu dropdown-menu-right shadow-lg">
													<li
														className="px-4 pb-3 pt-3"
														role="presentation"
														onClick={() => setSelectedJourneyToEdit(journey)}
													>
														<span className="font-weight-normal  text-black">
															Edit journey
														</span>
													</li>
												</ul>
											</div>
										</div>
									</td> */}
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
			{selectedJourneyToEdit && (
				<EditJourneyModal
					journeyTitle={selectedJourneyToEdit?.name}
					refetch={refetch}
					onClose={() => setSelectedJourneyToEdit(null)}
					selectedJourney={selectedJourneyToEdit}
				/>
			)}
		</>
	);
};

export default TaskJourneyConfiguration;
